/* eslint-disable consistent-this */
import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { Player } from 'ThreeTerminal_pc/video';

const VideoBox = errorBoundary(
    class extends PureComponent {
        state = {
            vConfig: {},
        };
        static propTypes = {
            content: PropTypes.object,
            play: PropTypes.bool,
        };

        componentDidMount() {
            const { content } = this.props;

            this.setState({
                vConfig: content.videoIntro[0],
            });
        }

        render() {
            const { content, play } = this.props;
            const { vConfig } = this.state;

            const playermsg = {
                width: 482,
                height: 395,
                autoPlay: play,
                controls: true,
            };

            // console.log('playermsg==', playermsg);

            return (
                <div className={styles.profileVedio}>
                    <div className={styles.profileVediobg}>
                        <Player videoConfig={vConfig} playermsg={playermsg} />
                    </div>
                </div>
            );
        }
    },
);

export { VideoBox };
export default VideoBox;
